const encodeString = (baseString) => window.btoa(baseString);
const decodeString = (encodedString) => window.atob(encodedString);

export { encodeString, decodeString };
